import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Slices/AuthSlice';
import walletReducer from "./Slices/WalletSlice";
import printReducer from "./Slices/printSlice";
import locationReducer from "./Slices/locationSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    wallet: walletReducer,
    print: printReducer,
    location: locationReducer,
  },
});

export default store;